<div style="text-align: center;padding-bottom:0" class="home-body-container">
    <img src="../../../assets/images/broken-screen/404-2.png" style="height: 50vh" alt="404">
</div>
<div style="text-align: center">
    <button class="btn-link" routerLink="/home">Back To Homepage</button>
</div>
